import { getErrorMessage } from "@/helpers/handleErrorResponse";
import { removeEmptyParams } from "@/helpers/objectHelpers";
import { GetAnalysisConfigurationListParams } from "@/types/analysis";
import { ConfigurationPayload, GetConfigurationParams } from "@/types/project";
import { CustomError } from "@/utils/errors";

import axiosInstance from "../config";

export const CONFIGURATION_PER_PAGE = 25;

export const getAllConfigurationApi = async (
  params?: GetAnalysisConfigurationListParams
) => {
  try {
    const { data } = await axiosInstance.get("/v1/analysis-configs", {
      params: {
        per_page: 100,
        ...params
      }
    });
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    const newError = new CustomError(message, status);
    throw newError;
  }
};

export const getConfigurationApi = async (
  pageNumber: number,
  params?: GetConfigurationParams
) => {
  try {
    const { data } = await axiosInstance.get("/v1/analysis-configs", {
      params: {
        per_page: CONFIGURATION_PER_PAGE,
        page: pageNumber,
        ...(params ? removeEmptyParams(params) : {})
      }
    });
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    const newError = new CustomError(message, status);
    throw newError;
  }
};

export const getSettingsApi = async () => {
  try {
    const { data } = await axiosInstance.get("/v1/analysis-settings");
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    const newError = new CustomError(message, status);
    throw newError;
  }
};

export const getConfigurationDetailApi = async (id: string) => {
  try {
    const { data } = await axiosInstance.get(`/v1/analysis-configs/${id}`);
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    const newError = new CustomError(message.message, status);
    throw newError;
  }
};

export const deleteConfigurationDetailApi = async (id: string) => {
  try {
    const { data } = await axiosInstance.delete(`/v1/analysis-configs/${id}`);
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    const newError = new CustomError(message, status);
    throw newError;
  }
};

export const saveConfigurationApi = async (payload: ConfigurationPayload) => {
  try {
    const { data } = await axiosInstance.post("/v1/analysis-configs", payload);
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    const newError = new CustomError(message, status);
    throw newError;
  }
};

export const updateConfigurationApi = async (payload: ConfigurationPayload) => {
  try {
    const { id, ...rest } = payload;
    const { data } = await axiosInstance.put(
      `/v1/analysis-configs/${id}`,
      rest
    );
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    const newError = new CustomError(message, status);
    throw newError;
  }
};

export const getAnalysisConfig = async (analysisId: string) => {
  try {
    const { data } = await axiosInstance.get(
      `/v1/analysis/${analysisId}/config`
    );
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    const newError = new CustomError(message, status);
    throw newError;
  }
};
